
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { round, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { replace, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import { empty, filter, ofArray, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { singleton, append, delay, toArray as toArray_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { Table_customPropertyColumnDefinitions } from "../../Widgets/CustomProperties.js";

export function ReportView(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["id", "consumable-stock-input-summed-report-id"], ["className", join(" ", ["h-full"])], (elems = [createElement(InfiniteTable, (TableRows = toArray(props.Report), {
        ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("displayName", "", t("general.name"), (row) => (new CellContent(3, [row.ConsumableInformation.Name, () => {
            RouterModule_nav(ofArray(toArray(row.ConsumableInformation.OnClickPath)), 1, 1);
        }])), "text", "button")), delay(() => append(singleton(new ColumnDefinition$1("additionalName", "", t("consumable.additional_name"), (row_1) => (new CellContent(0, [row_1.ConsumableInformation.AdditionalName])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("label", "", t("category.categories"), (row_2) => (new CellContent(4, [row_2.InventoryData.Labels])), "categorySelect", "text")), delay(() => append(singleton(new ColumnDefinition$1("quantity", "", t("report.consumable_stock_input_sum"), (row_3) => {
            let copyOfStruct;
            return new CellContent(0, [replace((copyOfStruct = round(row_3.Quantity, 2), copyOfStruct.toString()), ".", ",")]);
        }, "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("unit", "", t("general.unit"), (row_4) => (new CellContent(0, [t(Helper_unitToTranslationKey(row_4.ConsumableInformation.Unit))])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("supplierArticleNumber", t("tool.commercial_data"), t("general.supplier_article_number"), (row_5) => (new CellContent(0, [row_5.InventoryData.SupplierArticleNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("supplier", t("tool.commercial_data"), t("general.supplier"), (row_6) => (new CellContent(0, [row_6.InventoryData.Supplier])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("purchaseDate", t("tool.commercial_data"), t("general.purchase_date"), (row_7) => (new CellContent(8, [row_7.InventoryData.PurchaseDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("guranteeDate", t("tool.commercial_data"), t("general.gurantee_date"), (row_8) => (new CellContent(8, [row_8.InventoryData.WarrantyDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("purchasePrice", t("tool.commercial_data"), t("general.purchase_price"), (row_9) => (new CellContent(0, [row_9.InventoryData.PurchasePrice])), "text", "text")), delay(() => Table_customPropertyColumnDefinitions(filter((propertyConfiguration) => {
            const matchValue = propertyConfiguration.Visibility;
            switch (matchValue.tag) {
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 12:
                case 11:
                    return false;
                default:
                    return true;
            }
        }, props.PropertyConfigurations), t("tool.custom_properties"), (row_10) => row_10.InventoryData.CustomProperties, t, props.Configuration.Currency))))))))))))))))))))))),
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultSortColumn: ["displayName", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
            WithQueryParameters: false,
        },
        TableKey: "consumable-stock-input-summed-report",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

